module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_92.04164520.jpg";